import { type Components, type Theme } from '@mui/material/styles';
import { ChevronDown } from '@/static';

export const createComponents = (theme: Theme): Components => ({
  MuiButton: {
    styleOverrides: {
      outlined: {
        backgroundColor: theme.palette.background.white,
        color: theme.palette.text?.brand?.color_2,
        alignSelf: 'center',
        border: '1px solid',
        borderColor: theme.palette.text?.brand?.color_2,
        borderRadius: '40px',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: 1,
        gap: '4px',
        padding: '12px 24px',
        boxShadow: 'none',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: theme.palette.text?.brand?.color_2,
          borderColor: theme.palette.text?.brand?.color_2,
          boxShadow: 'none',
          color: theme.palette.text?.white,
        },
        '& .MuiButton-icon': {
          maxHeight: '16px',
          margin: 0,
        },
        '& svg, & path': {
          fill: 'currentColor',
        },
      },
      text: {
        borderRadius: '40px',
        color: theme.palette.text.brand.color_2,
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: 1,
        padding: '12px 16px',
        textTransform: 'none',
        '&:hover': {
          color: theme.palette.text?.brand?.color_2,
        },
        '&.MuiButton-sizeSmall': {
          fontSize: '12px',
        },
        '&.MuiButton-sizeLarge': {
          fontSize: '16px',
        },
      },
    },
    variants: [
      {
        props: { variant: 'mainBtn' },
        style: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 1,
          color: theme.palette.text?.white,
          backgroundColor: theme.palette.text?.brand?.color_2,
          alignSelf: 'center',
          border: '1px solid #4800F8',
          borderRadius: '40px',
          gap: '4px',
          padding: '12px 24px',
          boxShadow: 'none',
          textTransform: 'none',
          '&:disabled': {
            color: theme.palette.text?.white,
            opacity: 0.5,
          },
          '&:hover': {
            boxShadow: 'none',
            backgroundColor: 'transparent',
            color: theme.palette.text?.brand?.color_2,
            border: '1px solid #4800F8',
          },
          '& .MuiButton-icon': {
            maxHeight: '16px',
            margin: 0,
          },
          '& svg, & path': {
            fill: 'currentColor',
          },
        },
      },
      {
        props: { variant: 'mainBtn', size: 'large' },
        style: {
          width: '300px',
        },
      },
      {
        props: { variant: 'mainBtn', color: 'inherit' },
        style: {
          backgroundColor: '#fff',
          color: theme.palette.text?.brand.color_2,
          borderColor: theme.palette.text?.brand.color_2,
          '&:hover': {
            backgroundColor: '#fff',
            color: theme.palette.text?.brand.color_2,
            borderColor: theme.palette.text?.brand.color_2,
          },
          '&[aria-expanded="true"]': {
            backgroundColor: '#EDEFF0',
          },
        },
      },
    ],
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        boxShadow: '0px 2px 20px 0px #00000014',
      },
    },
  },
  MuiSelect: {
    defaultProps: {
      IconComponent: ChevronDown,
    },
    styleOverrides: {
      root: {
        '& .MuiSelect-icon': {
          top: '50%',
          transform: 'translateY(-50%)',
          '&.MuiSelect-iconOpen': {
            transform: 'translateY(-50%) rotate(180deg)',
          },
        },
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        '& fieldset': {
          borderColor: theme.palette.text.grey.blue_3,
        },
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.background.light,
        color: theme.palette.text.grey.blue_1,
        '& .MuiChip-label': {
          pr: 1,
        },
      },
    },
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        color: theme.palette.text.brand.color_2,
        padding: '8px',
        '&.Mui-checked': {
          color: theme.palette.text.brand.color_2,
        },
      },
    },
  },
});
